import { useCallback, useEffect, useState } from 'react';
import {
  getPayments,
  createPayment,
  bulkCreatePayments,
  updatePayment,
  deletePayment,
} from '../services/paymentsService';

export function usePayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    return getPayments()
      .then((data) => {
        setPayments(data);
        setError('');
      })
      .catch((err) => setError(err.message || 'Failed to load payments'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const create = useCallback(
    async (paymentData) => {
      await createPayment(paymentData);
      await refetch();
    },
    [refetch]
  );

  const bulkCreate = useCallback(
    async (rows) => {
      await bulkCreatePayments(rows);
      await refetch();
    },
    [refetch]
  );

  const update = useCallback(
    async (id, paymentData, previousData) => {
      await updatePayment(id, paymentData, previousData);
      await refetch();
    },
    [refetch]
  );

  const remove = useCallback(
    async (id, record) => {
      await deletePayment(id, record);
      await refetch();
    },
    [refetch]
  );

  return { payments, loading, error, create, bulkCreate, update, remove };
}
